<template>

  <div class="httpMessagesWrapper">

    <article v-if="failure" class="message is-danger">
      <div class="message-header is-radiusless">
        <p>{{ messages.errors.header }}</p>
      </div>
      <div class="message-body">{{ messages.errors.body }}</div>
    </article>

    <article v-if="success" class="message is-success">
      <div class="message-header is-radiusless">
        <p>{{ messages.success.header }}</p>
      </div>
      <div class="message-body">{{ messages.success.body }}</div>
    </article>

  </div>

</template>

<script>
export default {
  props: [
    'success',
    'errors',
    'message'
  ],
  computed: {
    messages () {
      let messages = {
        success: {
          header: 'Geslaagd!',
          body: 'De data is opgeslagen op de server.'
        },
        errors: {
          header: 'Er ging iets mis',
          body: 'Er ging iets mis bij het opslaan. Controleer de met rood gemarkeerde velden en pas zonodig de gegevens aan. Probeer het daarna nogmaals.'
        }
      }

      if (this.message) {
        messages.success.body = this.message
      }

      return messages
    },
    failure () {
      return this.hasErrors()
    }
  },
  methods: {
    hasErrors() {
      for(var key in this.errors) {
        if (this.errors.hasOwnProperty(key)) {
          return true
        }
      }

      return false
    },
  }
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// src/components/http/HttpMessages.vue